import React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const NavigationBarTasksSelected = (props) => (<Svg viewBox="0 0 25 24" fill="none" {...props}>
    <Rect x={3.46704} y={2.76929} width={18.4615} height={18.4615} rx={2.76923} fill="#3999DE"/>
    <Path d="M9.96704 11.077L12.7363 13.8462L21.967 4.61548" stroke="white" strokeWidth={1.84615} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default NavigationBarTasksSelected;
